import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import * as Connection from "./../libs/connections";

import HeroBanner from "./../components/HeroBanner";
import SectionImageText from "../components/SectionImageText";
import SectionContact from "../components/SectionContact";

import Preloader from "./../components/global/Preloader";

import "../styles/sites/ContactPage.css";

// import mouse from "../assets/icons-main/mouse.png";

export default class ContactPage extends Component {
  constructor() {
    super();

    this.state = {
      loading: true
    };
  }

  componentDidMount() {
    (async () => {
      try {
        const response = await Connection.getPageBySlug("kontakt");
        this.setState({
          data: response.acf,
          loading: false
        });
      } catch (err) {
        this.setState({
          error: true
        });
      }
    })().catch(err => {
      console.error(err);
    });
  }

  render() {
    if (!this.state.error) {
      return (
        <div className="page-contact line">
          {/* <img className="mouse" src={mouse} alt="" /> */}
          <Preloader global loading={this.state.loading} />
          {this.state.data && (
            <HeroBanner
              backgroundFixed
              backgroundImage={this.state.data.contact.heroPhoto}
              headerText={this.state.data.contact.heroTitle}
              custom={true}
              showFooter={true}
            />
          )}
          {this.state.data && (
            <SectionImageText
              text={this.state.data["section-text-photo-value"]}
              wrapperClasses={`container`}
              backgroundImage={this.state.data["section-text-photo-url"]["url"]}
              showButtonContact
            />
          )}
          {this.state.data && (
            <SectionContact
              data={this.state.data["contactForm_2"]}
              version={2}
              pageType="send-form-contact"
            />
          )}
        </div>
      );
    } else {
      return <Redirect to="/error" />;
    }
  }
}
